import { REGISTRATION_TYPES } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'registration_types_2',
  type: REGISTRATION_TYPES,
  name: 'Registration type table',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/registration_types/registration_types_2.jpg',
  rootContent: {
    type: contentTypes.REGISTRATION_TYPE_TABLE,
    properties: {
      color: {type: 'custom', value: '#545454', editable: true},
      accentColor: {type: 'custom', value: '#794583', editable: true},
      backgroundColor: {type: 'custom', value: '#F3F3F3', editable: true},
      showPrice: {type: 'custom', value: true, editable: true},
      showVAT: {type: 'custom', value: true, editable: true},
      showAvailability: {type: 'custom', value: true, editable: true},
    }
  }
}
